export default "__VITE_ASSET__PS_q9Z80__"